import { bucketDesignType } from "../manageBucket/ManageBucketTypes";

export const bucketDesigns: bucketDesignType[] = [{
    id: "Carousel",
    label: "Grid"
},{
    id: "1DGrid",
    label: "Carousel"
},{
    id: "Grid",
    label: "2D Grid"
},{
    id: "Need Based Basket Banner",
    label: "Need Based Basket Banner"
},{
    id: "basketBannerOneClick",
    label: "Basket Oneclick Banner"
},{ 
    id: "campaignBanner", 
    label: "Campaign Banner" 
}];

export const bucketTypes = ["Category","Brand","Pack Size", "Smart Buy", "Sub Category", "Sub Brand", "Piece Size Description", "Brand Code"];
